import { httpClient } from './httpClient';

export const login = async (email, password) => {
  const response = await httpClient.post('/auth/login', { email, password });
  return response.data;
};

export const logout = async () => {
  const response = await httpClient.post('/auth/logout');
  return response.data;
};

export const register = async (name, phoneNumber, email, password, passwordConfirmation, companyId, price_id) => {
  const response = await httpClient.post('/auth/register', { name, phone_number: phoneNumber, email, password, password_confirmation: passwordConfirmation, company_id: companyId, price_id });
  return response.data;
};

export const resetPasswordPhone = async (phoneNumber, password, confirmPassword) => {
  const response = await httpClient.post('/auth/reset-password-phone', { phone_number: phoneNumber, password, confirm_password: confirmPassword });
  return response.data;
};

export const resetIdPhone = async (phoneNumber, email, confirmEmail) => {
  const response = await httpClient.post('/auth/reset-id-phone', { phone_number: phoneNumber, email, confirm_email: confirmEmail });
  return response.data;
};

export const checkPhoneExists = async (phoneNumber) => {
  const response = await httpClient.post('/auth/check-phone-exists', { phone_number: phoneNumber });
  return response.data;
};

export const sendOtp = async (phoneNumber) => {
  const response = await httpClient.post('/auth/send-otp', { phone: phoneNumber });
  return response.data;
};

export const verifyOtp = async (phoneNumber, otp) => {
  const response = await httpClient.post('/auth/verify-otp', { phone: phoneNumber, otp });
  return response.data;
};